export const DEFAULT_VALUES = {
  isin: {
    value: "",
    operator: "=",
  },
  productName: {
    value: "",
    operator: "=",
  },

  issuerName: {
    value: "",
    operator: "=",
  },
  issuerLEI: {
    value: "",
    operator: "=",
  },
  lastUpdateDate: {
    value: null,
    range: { from: null, to: null },
    operator: "[]",
  },
};

export const OPERATORS_ALLOWED = {
  lastUpdateDate: ["=", "[]"],
};

export const ERROR_DEFAULT_VALUES = {
  isin: {
    error: false,
    helperText: "",
    length: 12,
    pattern: "^[A-Z0-9]*$",
    fullPattern: "^[A-Z]{2}[A-Z0-9]{9}[0-9]{1}$",
  },
  productName: {
    error: false,
    helperText: "",
    length: 100,
    pattern: "^[ A-Za-z0-9+.:=_/\u00C0-\u017F.\\-]*$",
  },
  issuerName: {
    error: false,
    helperText: "",
    length: 100,
    pattern: "^[ A-Za-z0-9+.:=_/,\u00C0-\u017F.\\-]*$",
  },
  issuerLEI: {
    error: false,
    helperText: "",
    length: 20,
    pattern: "^[ A-Za-z0-9+.:=_/\u00C0-\u017F.\\-]*$",
  },
};
